// extracted by mini-css-extract-plugin
export default {"star-rating":"_1mc2nizGa42dL5HpWBVVyV","star-rating__filled":"VNYIeVpRYKgGbTZEtWrpK","star-rating__icon":"BaobzO6tk89LQHZGnMy5Z","star-rating__empty":"_2ppLbDH1KH7Qv4IiJd1lRD"};